import { Component, Inject, OnInit } from "@angular/core";
import { TuiDialogContext } from "@taiga-ui/core";
import { POLYMORPHEUS_CONTEXT } from "@tinkoff/ng-polymorpheus";
@Component({
  selector: "app-result-notepopup",
  templateUrl: "./result-notepopup.component.html",
  styleUrls: ["./result-notepopup.component.scss"],
})
export class ResultNotepopupComponent implements OnInit {
  constructor(
    @Inject(POLYMORPHEUS_CONTEXT)
    private readonly context: TuiDialogContext<any, any>
  ) {
    const dialog = document.querySelector("tui-dialog");
    dialog.classList.add("result-notepopup");
  }

  ngOnInit(): void {}
  close() {
    this.context.completeWith("");
  }
}
